import styled from '@emotion/styled';

export const GrayArea = styled.div`
  ${({ theme }) => theme.media.showAt({ from: 3 })`
    background-color: ${theme.colors.neutrals.grey11};
  `}
`;
